import {GeneralContract} from '../../models/api/product/base.model';
import {Calculation} from '../../models/api/calculation.model';
import {RiskDefinition} from '../../models/api/riskDefinition.model';
import {GeneralContractFLEET} from '../../models/api/product/fleet.model';
import {PersonalDataFormModel} from '../../modules/shared/components/personal-data-form/services/personal-data-form.model';
import {ValidationErrors} from '@angular/forms';

export namespace CalculationEditActions {
    export class SetCalculationData {
        static readonly type = 'CalculationEditActions.SetCalculationData';

        constructor(
            public generalContract: GeneralContract,
            public originalCalculation?: Calculation
        ) {}
    }

    export class SetRisksDefinition {
        static readonly type = 'CalculationEditActions.SetRisksDefinition';

        constructor(public risksDefinition: RiskDefinition) {}
    }

    export class SetFleetRisksDefinition {
        static readonly type = 'CalculationEditActions.SetFleetRisksDefinition';

        constructor(
            public risksDefinition: RiskDefinition,
            public generalContract: GeneralContractFLEET
        ) {}
    }

    export class ClearState {
        static readonly type = 'CalculationEditActions.ClearState';
    }

    export class SetVehicleMakeList {
        static readonly type = 'CalculationEditActions.SetVehicleMakeList';

        constructor(public vehicleMakeList: string[]) {}
    }

    export class Calculate {
        static readonly type = 'CalculationEditActions.Calculate';

        constructor(
            public body: any,
            public productCode: string
        ) {}
    }

    export class Save {
        static readonly type = 'CalculationEditActions.Save';

        constructor(
            public body: any,
            public productCode: string
        ) {}
    }

    export class SetBlockSave {
        static readonly type = 'CalculationEditActions.SetBlockSave';

        constructor(public blockSave: boolean) {}
    }
}
